var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaptain3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 593,
    height: 1137,
    viewBox: "0 0 593 1137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.26 996.87C11.26 996.87 9.88999 1021.59 5.07999 1029.15C0.269987 1036.71 1.95999 1048.38 0.429987 1058.68C-1.10001 1068.98 1.95999 1048.38 1.95999 1048.38L0.429987 1062.91C0.429987 1062.91 5.02999 1069.99 8.10999 1070.91C11.19 1071.83 13.96 1069.68 17.96 1070.91C21.96 1072.14 27.81 1076.45 30.27 1076.45C32.73 1076.45 43.5 1074.3 46.27 1074.6C49.04 1074.9 57.66 1078.29 62.89 1078.29C68.12 1078.29 86.5 1055.52 86.5 1055.52L80.12 1017.67L74.27 986.9L11.26 996.87Z",
    fill: "#FCD7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.49 998C569.49 998 571.02 1025.51 576.37 1033.92C581.72 1042.33 579.84 1055.32 581.54 1066.78C583.24 1078.24 579.84 1055.32 579.84 1055.32L581.54 1071.5C581.54 1071.5 576.42 1079.38 573 1080.4C569.58 1081.42 566.49 1079.03 562.04 1080.4C557.59 1081.77 551.08 1086.56 548.34 1086.56C545.6 1086.56 533.61 1084.16 530.53 1084.51C527.45 1084.86 517.86 1088.62 512.04 1088.62C506.22 1088.62 485.76 1063.28 485.76 1063.28L492.86 1021.15L499.37 986.9L569.5 998H569.49Z",
    fill: "#FCD7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4001 386.12C11.4001 386.12 3.31005 585.46 1.26005 624.58C-0.789947 663.7 2.28005 687.25 1.26005 715.91C0.240053 744.57 4.62005 998.52 0.540053 1014.26C-3.53995 1030 104.65 1014.26 104.65 1014.26C104.65 1014.26 100.1 831.63 106.52 773.4C112.95 715.17 172.55 364.57 172.55 364.57L11.3901 386.11L11.4001 386.12Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.02 372.73C582.02 372.73 589.88 585.46 591.93 624.59C593.98 663.71 590.91 687.26 591.93 715.92C592.95 744.58 588.57 998.53 592.65 1014.27C596.73 1030.01 488.54 1014.27 488.54 1014.27C488.54 1014.27 493.09 831.64 486.67 773.41C480.25 715.18 420.64 364.58 420.64 364.58L582.03 372.73H582.02Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.41 1019.58C58.41 1019.58 64.26 877.86 69.08 861.18C73.9 844.5 74.06 812.38 74.06 812.38C74.06 812.38 80.84 773.1 80.62 769.89C80.4 766.68 85.44 732.88 86.49 721.64C87.55 710.4 92.8 635.72 88.57 631.7C84.33 627.68 88.79 600.08 88.57 581.36C88.35 562.64 90.25 456.19 90.25 456.19L106.02 501.53L118.87 756.02L106.82 956.13L58.41 1019.59V1019.58Z",
    fill: "#0C0901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.11 456.18C461.11 456.18 466.96 597.9 471.78 614.58C476.6 631.26 476.76 663.38 476.76 663.38C476.76 663.38 483.54 702.66 483.32 705.87C483.1 709.08 488.14 742.88 489.19 754.12C490.25 765.36 495.5 840.04 491.27 844.06C487.04 848.08 491.49 875.68 491.27 894.4C491.05 913.12 492.95 1019.57 492.95 1019.57L508.72 974.23L521.57 719.74L509.52 519.63L461.11 456.17V456.18Z",
    fill: "#0C0901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.57 821.18L97.59 759.85C97.59 759.85 103 624.97 97.59 572.45C92.18 519.93 117.25 364.92 140.7 355.9C164.15 346.88 391.62 343.16 391.62 343.16L503.46 372.02C503.46 372.02 514.28 534.37 514.28 582.17C514.28 629.97 499.85 774.28 499.85 788.71C499.85 803.14 505.26 837.41 505.26 837.41C505.26 837.41 507.06 1077.79 505.26 1104.85C503.46 1131.91 234.68 1140.93 166.14 1133.71C97.59 1126.49 66.93 1088.61 66.93 1088.61C66.93 1088.61 59.71 942.03 66.93 900.54C74.15 859.05 88.58 821.17 88.58 821.17L88.57 821.18Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.4 235.72C387.4 235.72 379.56 268.87 381.88 282.91C384.2 296.95 384.43 335.97 384.43 335.97L235.42 372.73L345.16 225.62L387.41 235.72H387.4Z",
    fill: "#FCD7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.51 281.49C219.51 281.49 262.07 350.69 278.03 361.31C278.03 361.31 340.64 349.84 381.88 282.91L395.07 321.4C395.07 321.4 301.08 579.42 251.43 691.14C251.43 691.14 214.19 320.51 219.51 281.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.03 369.3L323.48 437.64L378.62 353.13L324.39 417.6L287.03 369.3Z",
    fill: "#C7D4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.81 368.19L245.77 424.15L223.63 363.18L245.77 405.92L270.81 368.19Z",
    fill: "#C7D4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.46 358.71H274.8L257.59 397.49L266.57 421.89H288.15L303.11 398.45L282.46 358.71Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.15 421.89L319.26 544.01L251.43 691.14L230.33 530.87L266.57 421.89",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.83 337.06L137.64 354.61L293.34 710.43L218.99 332.92L207.83 337.06Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.035 93.8663C468.824 47.4643 401.649 5.67409 315.996 0.525306C230.342 -4.62348 158.644 28.8189 155.855 75.2209C153.066 121.623 220.241 163.413 305.895 168.562C391.548 173.711 463.246 140.268 466.035 93.8663Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.19 3.17015C399.19 8.22015 464.75 47.6601 466.1 92.3101C467.22 46.6201 400.76 5.77015 316.19 0.630147C230.54 -4.57985 158.76 28.8201 155.86 75.2101C155.77 76.6501 155.75 78.0801 155.79 79.5001C155.8 78.9201 155.82 78.3301 155.86 77.7501C158.76 31.3501 230.54 -2.03985 316.19 3.17015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.41 111.9L198.45 234.42L228.19 321.5L344.57 291.92L371.83 238.25L383.37 149.75L205.41 111.9Z",
    fill: "#FCD7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.42 156.55L358.49 244.18L300.94 287.34H221.27L198.45 234.43C198.45 234.43 193.04 297.77 192.11 316.33C191.18 334.89 207.88 354.37 241.29 358.08C274.7 361.79 298.62 359.94 315.42 343.23C332.22 326.53 366.55 294.98 366.55 294.98L379.41 156.55H379.42Z",
    fill: "#CCCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.34 296.71C224.34 296.71 248.69 304.38 256.11 306.18C263.54 307.98 281.46 296.71 281.46 296.71L252.8 288.62L224.34 296.71Z",
    fill: "#FCD7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.08 227.43C244.08 227.43 255.24 153.29 263.44 149.86C271.64 146.43 275.06 226.58 275.06 226.58C275.06 226.58 295.95 232.4 295.74 246.31C295.52 260.22 282.45 261.52 272.59 262.2C262.73 262.88 244.26 261.96 233.97 262.2C225.53 262.4 206 235.05 244.08 227.43Z",
    fill: "#FFAF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.43 260.39C261.43 260.39 270.44 251.41 278.48 256.3L286.52 261.19L261.44 260.39H261.43Z",
    fill: "#56445E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.03 262.08C250.03 262.08 242.01 252.2 233.51 256.22L225 260.24L250.03 262.08Z",
    fill: "#56445E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.51 264.78C212.51 264.78 189.46 279.66 165.09 315.08C165.09 315.08 201.7 326.73 223.03 310.48C244.36 294.23 244.36 301.35 254.52 298.3C264.68 295.25 270.74 268 254.52 261.73C229.62 252.1 212.51 264.78 212.51 264.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.59 264.78C299.59 264.78 335.8 286.11 352.05 325.72C352.05 325.72 310.4 326.74 289.07 310.48C267.74 294.23 267.74 301.35 257.58 298.3C247.42 295.25 241.36 268 257.58 261.73C282.48 252.1 299.59 264.78 299.59 264.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.56 294.98C366.56 294.98 407.42 219.15 407.42 181.86C407.42 144.57 382.5 128.66 382.5 128.66L378.32 161.12L359.31 290.62L366.56 294.98Z",
    fill: "#CCCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.73 192.07C393.73 192.07 412.46 187.36 407.42 222.56C402.38 257.76 372.12 252.2 372.12 252.2L387.56 192.07H393.74H393.73Z",
    fill: "#FCD7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.9 200.88C389.9 200.88 403.15 197.55 399.58 222.45C396.01 247.35 374.61 243.42 374.61 243.42L385.53 200.88H389.9Z",
    fill: "#FFAF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.69 128.66L198.46 159.46C198.46 159.46 171.92 167.74 178.89 172.1C185.86 176.46 375.07 169.05 378.99 165.56C382.91 162.07 383.37 149.75 383.37 149.75C383.37 149.75 317.09 97.4204 200.69 128.66Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.42 146.08C199.42 146.08 362.46 139.94 407.42 181.86L413.4 136.3C413.4 136.3 332.2 98.3695 201.84 111.89L199.43 146.07L199.42 146.08Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.54 67.6197C349.25 65.6497 409.58 98.4697 413.24 129.75C413.4 128.36 413.49 126.96 413.49 125.54C413.49 92.2997 347.26 61.4697 290.9 61.4697C234.54 61.4697 201.01 93.3297 201.01 126.57C201.01 127.99 201.1 129.39 201.26 130.78C204.92 99.5097 226.59 69.1797 280.53 67.6297L280.54 67.6197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.54 65.61C349.25 63.64 409.58 96.46 413.24 127.74C413.4 126.35 413.49 124.95 413.49 123.53C413.49 90.29 347.26 59.46 290.9 59.46C234.54 59.46 201.01 91.32 201.01 124.56C201.01 125.98 201.1 127.38 201.26 128.77C204.92 97.5 226.59 67.17 280.53 65.62L280.54 65.61Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.419 96.8048C290.198 85.8585 285.44 75.9772 277.792 74.7344C270.143 73.4915 262.501 81.3577 260.723 92.304C258.944 103.25 263.702 113.132 271.35 114.374C278.998 115.617 286.64 107.751 288.419 96.8048Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.99 165.57C378.99 165.57 400.19 174.99 407.42 181.86C407.42 181.86 397.5 167.24 378.99 165.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.51 130.77L326.52 146.08L337.72 147.87L339.96 131.93L328.51 130.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.67 149.75L353.91 128.66L368.35 130.77L365.54 151.6L350.67 149.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.56 145.25L316.58 146.08L318.3 130.77H311.93L310.56 145.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.81 209.73C309.072 209.73 316.58 202.222 316.58 192.96C316.58 183.699 309.072 176.19 299.81 176.19C290.548 176.19 283.04 183.699 283.04 192.96C283.04 202.222 290.548 209.73 299.81 209.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.34 206.1C299.896 206.1 305.21 200.786 305.21 194.23C305.21 187.675 299.896 182.36 293.34 182.36C286.784 182.36 281.47 187.675 281.47 194.23C281.47 200.786 286.784 206.1 293.34 206.1Z",
    fill: "#3B496D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.36 198.76L316.09 196.96C316.09 196.96 313.8 210.1 299.81 210.61C286.37 211.1 282.37 198.76 282.37 198.76H282.36Z",
    fill: "#FFAF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.23 193.38C285.069 193.38 285.75 192.699 285.75 191.86C285.75 191.02 285.069 190.34 284.23 190.34C283.391 190.34 282.71 191.02 282.71 191.86C282.71 192.699 283.391 193.38 284.23 193.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.3 170.74L283.63 176.33L317.56 177.3L319.26 167.2L283.3 170.74Z",
    fill: "#CCCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.92 211.71C234.182 211.71 241.69 204.202 241.69 194.94C241.69 185.678 234.182 178.17 224.92 178.17C215.658 178.17 208.15 185.678 208.15 194.94C208.15 204.202 215.658 211.71 224.92 211.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.46 208.08C225.016 208.08 230.33 202.765 230.33 196.21C230.33 189.654 225.016 184.34 218.46 184.34C211.904 184.34 206.59 189.654 206.59 196.21C206.59 202.765 211.904 208.08 218.46 208.08Z",
    fill: "#3B496D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.48 200.73L241.21 198.93C241.21 198.93 238.92 212.07 224.93 212.58C211.49 213.07 207.49 200.73 207.49 200.73H207.48Z",
    fill: "#FFAF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.34 195.35C210.18 195.35 210.86 194.669 210.86 193.83C210.86 192.99 210.18 192.31 209.34 192.31C208.501 192.31 207.82 192.99 207.82 193.83C207.82 194.669 208.501 195.35 209.34 195.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.56 174.22L204.22 179.77L238.15 178.71L239.25 168.52L203.56 174.22Z",
    fill: "#CCCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.08 150.84C199.08 150.84 321.49 125.09 409.41 166.7L408.82 171.23C408.82 171.23 327.74 128.66 198.79 154.84L199.08 150.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.08 151.86C199.08 151.86 321.49 126.11 409.41 167.72L408.82 172.25C408.82 172.25 327.74 129.68 198.79 155.86L199.08 151.86Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.27 196C318.27 196 333.11 187.75 331.78 189.08C330.45 190.41 318.27 196 318.27 196Z",
    fill: "#FFAF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.78 196.76C318.78 196.76 334.81 191.17 333.27 192.25C331.73 193.33 318.78 196.76 318.78 196.76Z",
    fill: "#FFAF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.6 197.82C319.6 197.82 336.35 195.02 334.65 195.82C332.95 196.62 319.6 197.82 319.6 197.82Z",
    fill: "#FFAF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.7 196.97C206.7 196.97 201.53 189.23 202 190.48C202.47 191.73 206.7 196.97 206.7 196.97Z",
    fill: "#FFAF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.52 197.68C206.52 197.68 200.94 192.44 201.47 193.45C202 194.46 206.52 197.68 206.52 197.68Z",
    fill: "#FFAF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.24 198.67C206.24 198.67 200.41 196.04 201 196.8C201.59 197.56 206.24 198.67 206.24 198.67Z",
    fill: "#FFAF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.4 299.17L447.17 343.15L428.96 470.64L265.96 781.37L155.77 710.42C155.77 710.42 387.4 362.62 387.4 299.16V299.17Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.17 343.16L582.02 372.73L533.89 406.38L442.65 374.77L447.17 343.16Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.77 349.38L11.4 386.12L52.82 417.83L151.6 386.5L160.77 349.38Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.34 1062.52V679.06",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.8 757.72C234.279 757.72 238.72 753.279 238.72 747.8C238.72 742.321 234.279 737.88 228.8 737.88C223.321 737.88 218.88 742.321 218.88 747.8C218.88 753.279 223.321 757.72 228.8 757.72Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.76 757.72C348.239 757.72 352.68 753.279 352.68 747.8C352.68 742.321 348.239 737.88 342.76 737.88C337.281 737.88 332.84 742.321 332.84 747.8C332.84 753.279 337.281 757.72 342.76 757.72Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.54 593.01C373.968 593.01 380.8 586.178 380.8 577.75C380.8 569.322 373.968 562.49 365.54 562.49C357.112 562.49 350.28 569.322 350.28 577.75C350.28 586.178 357.112 593.01 365.54 593.01Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.09 593.01C406.518 593.01 413.35 586.178 413.35 577.75C413.35 569.322 406.518 562.49 398.09 562.49C389.662 562.49 382.83 569.322 382.83 577.75C382.83 586.178 389.662 593.01 398.09 593.01Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.11 593.01C439.538 593.01 446.37 586.178 446.37 577.75C446.37 569.322 439.538 562.49 431.11 562.49C422.682 562.49 415.85 569.322 415.85 577.75C415.85 586.178 422.682 593.01 431.11 593.01Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.26 593.01C474.688 593.01 481.52 586.178 481.52 577.75C481.52 569.322 474.688 562.49 466.26 562.49C457.832 562.49 451 569.322 451 577.75C451 586.178 457.832 593.01 466.26 593.01Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93 900.199C239.409 900.199 243.85 895.758 243.85 890.279C243.85 884.801 239.409 880.359 233.93 880.359C228.451 880.359 224.01 884.801 224.01 890.279C224.01 895.758 228.451 900.199 233.93 900.199Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.92 831.84C237.399 831.84 241.84 827.399 241.84 821.92C241.84 816.441 237.399 812 231.92 812C226.441 812 222 816.441 222 821.92C222 827.399 226.441 831.84 231.92 831.84Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.89 900.199C353.369 900.199 357.81 895.758 357.81 890.279C357.81 884.801 353.369 880.359 347.89 880.359C342.411 880.359 337.97 884.801 337.97 890.279C337.97 895.758 342.411 900.199 347.89 900.199Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.88 831.84C351.359 831.84 355.8 827.399 355.8 821.92C355.8 816.441 351.359 812 345.88 812C340.401 812 335.96 816.441 335.96 821.92C335.96 827.399 340.401 831.84 345.88 831.84Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36 972.47C241.839 972.47 246.28 968.029 246.28 962.55C246.28 957.071 241.839 952.63 236.36 952.63C230.881 952.63 226.44 957.071 226.44 962.55C226.44 968.029 230.881 972.47 236.36 972.47Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.32 972.47C355.799 972.47 360.24 968.029 360.24 962.55C360.24 957.071 355.799 952.63 350.32 952.63C344.841 952.63 340.4 957.071 340.4 962.55C340.4 968.029 344.841 972.47 350.32 972.47Z",
    fill: "#EAD25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.27 370.42L549.62 401.22",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.17 347.78L573.65 378.58",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.88 377.16L40.45 412.54",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.98 354.52L14.6 392.12",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.17 343.16L429.44 469.22L368.35 465.98L456.34 470.65L209.34 679.06L302.3 477.42",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.77 349.38L137.64 442.99H172.56H109.24L236.19 620.83L260.18 568.79L247.22 476.26",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 592.77,
    height: 1136.1,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptain3);
export default __webpack_public_path__ + "static/media/captain3.svg";
export { ForwardRef as ReactComponent };